type Environment = 'qa' | 'production';

interface ZohoConfiguration {
    ZOHO_SCRIPT_ID: string | null;
    ZOHO_SALES_SCRIPT_SRC: string | null;
    ZOHO_SCRIPT_ACTIVE: boolean;
    ZOHO_DEPARTMENT: string;
}

interface EnvironmentConfig {
    environment: Environment;
    configuration: ZohoConfiguration;
}

const getEnvironment = (): Environment => {
    const hostname = window.location.hostname;

    if (hostname.includes('localhost') || hostname.includes('amazonaws.com')) {
        return 'qa';
    }

    if (hostname.includes('portal-colaborador.coderland.com')) {
        return 'production';
    }

    return 'qa';
}

/**
 * Carga la configuración del entorno detectado por hostname (ver getEnvironment).
 * La forma del retorno vive ahora en EnvironmentConfig / ZohoConfiguration.
 */
export const loadEnvironmentConfig = (): EnvironmentConfig => {
    const env = getEnvironment();

    const configurations: Record<Environment, ZohoConfiguration> = {
        qa: {
            ZOHO_SCRIPT_ID: import.meta.env.VITE_ZOHO_SCRIPT_ID || null,
            ZOHO_SALES_SCRIPT_SRC: import.meta.env.VITE_ZOHO_SALES_SCRIPT_SRC || null,
            ZOHO_SCRIPT_ACTIVE: import.meta.env.VITE_ZOHO_SCRIPT_ACTIVE === 'true',
            ZOHO_DEPARTMENT: import.meta.env.VITE_ZOHO_DEPARTMENT || 'People & Culture',
        },
        production: {
            ZOHO_SCRIPT_ID: import.meta.env.VITE_ZOHO_SCRIPT_ID || 'zoho-prod-script',
            ZOHO_SALES_SCRIPT_SRC: import.meta.env.VITE_ZOHO_SALES_SCRIPT_SRC || 'https://salesiq.zohopublic.com/widget?wc=prod_widget_code',
            ZOHO_SCRIPT_ACTIVE: import.meta.env.VITE_ZOHO_SCRIPT_ACTIVE === 'true',
            ZOHO_DEPARTMENT: import.meta.env.VITE_ZOHO_DEPARTMENT || 'People & Culture',
        }
    }

    return {
        environment: env,
        configuration: configurations[env] || configurations['qa']
    }
};